import { ICoworkingAmenityNames } from '@cian/api-models/offer-card/v1/get-offer-data';

interface ICoworkingAmenitiesGroups {
  key: string;
  title: string;
  availableAmenities: ICoworkingAmenityNames[];
}

export const coworkingAmenitiesGroups: ICoworkingAmenitiesGroups[] = [
  {
    key: 'commonAmenities',
    title: 'Ключевые удобства',
    availableAmenities: ['modern', 'furniture', 'wifi', 'internet', 'legalAddress', 'security'],
  },
  {
    key: 'equipment',
    title: 'Оборудование',
    availableAmenities: ['printer', 'fax', 'flipchart'],
  },
  {
    key: 'food&drinks',
    title: 'Еда и напитки',
    availableAmenities: ['tea', 'fruits', 'kitchen', 'cafe'],
  },
  {
    key: 'services',
    title: 'Услуги',
    availableAmenities: ['techSupport', 'reception', 'cleaning'],
  },
  {
    key: 'specialZones',
    title: 'Специальные зоны',
    availableAmenities: ['lockers', 'phoneBooth', 'meetingRoom'],
  },
  {
    key: 'communication',
    title: 'Общение',
    availableAmenities: ['restZone', 'events'],
  },
  {
    key: 'transport',
    title: 'Транспорт',
    availableAmenities: ['parking', 'bikeParking'],
  },
  {
    key: 'health',
    title: 'Здоровье',
    availableAmenities: ['gym'],
  },
];
